module.exports = __webpack_public_path__ + "static/hero2-ced2a8fe9f388e4639820b80ded0aac3.mp4";